import Events from "@wwdev/bootstrap/Events";

class Orders {
    constructor(config) {
        this.$scope = $('.table-orders');
        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$scope.on('click', 'tbody tr', this.toggle.bind(this));

    }

    toggle(e) {
        jQuery(e.currentTarget).parents('table').find('.details:visible').each(function(it,el){
            jQuery(el).find('.collapse').off('hidden.bs.collapse').on('hidden.bs.collapse', function () {
                jQuery(el).addClass('d-none');
            })
            jQuery(el).find('.collapse').collapse('hide');
        })
        if ( jQuery(e.currentTarget).next().hasClass('d-none') ) {
            jQuery(e.currentTarget).next().removeClass('d-none');
            jQuery(e.currentTarget).next().find('.collapse').collapse('show');
        } else {
            jQuery('.collapse').off('hidden.bs.collapse').on('hidden.bs.collapse', function () {
                jQuery(e.currentTarget).next().addClass('d-none');
            })
            jQuery(e.currentTarget).next().find('.collapse').collapse('hide');

        }
    }

    primaryAnimation($button, $scope) {
        $scope.find(this.config.hide).animate({
            width: 'hide',
            marginLeft: "-50px",
            paddingRight: "50px",
            opacity: "0",
        }, 200);

        let $show = $scope.find(this.config.show);
        $show.animate({
            marginLeft: "0",
            opacity: "1",
        }, 200, () => {
            $show.css('pointer-events', 'unset');
            $scope.find(this.config.amount).focus();
        });
    }

    secondaryAnimation($button, $scope) {
        let $hide = $scope.find(this.config.hide);
        $hide.animate({
            opacity: ".5",
        }, 200);
        $hide.css('pointer-events', 'none')

        let $show = $scope.find(this.config.show);
        $show.animate({
            opacity: "1"
        }, 200, () => {
            $show.css('pointer-events', 'unset');
            $scope.find(this.config.amount).focus();
        });
        $show.removeClass('d-none');
    }

    addToCart(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        let data = $form.serializeObject();

        $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: data,
            success: () => {
                let $message = $('<div class="alert alert-success m-0"></div>')
                $message.html($form.data('success-message'));
                $form.before($message);
                $form.remove();
                Events.trigger('wwdev.wishlist.indicator');
            }
        });
    }
}

export default new Orders;